import { Dispatch } from "react";
import { createAsyncThunk } from "@reduxjs/toolkit";

import { UserDrivingPermitService } from "Bands/services";
import { API_ENDPOINTS } from "shared/constants";
import { IDataKeys } from "shared/types";
import { USER_ACTIONS, IUserDrivingPermitPatchData } from "Bands/types";
import { IStoreState } from "App/types";

export const dispatchGetUserDrivingPermits = (dispatch: Dispatch<any>, userId?: string) => {
  dispatch(
    getUserDrivingPermits({
      userId,
      page: 1,
      paginationKey: USER_ACTIONS.getUserDrivingPermits,
    })
  );
};

const getUserDrivingPermits = createAsyncThunk(
  USER_ACTIONS.getUserDrivingPermits,
  async (
    { userId }: { userId?: string; page: number; paginationKey: string },
    { getState, rejectWithValue }
  ) => {
    try {
      const { currentUser } = (getState() as IStoreState).auth;

      const data = await UserDrivingPermitService.getUserDrivingPermits({
        user: API_ENDPOINTS.USER(userId || currentUser?.id || ""),
      });

      return {
        [IDataKeys.userDrivingPermit]: data.userDrivingPermit,
        meta: data.meta,
        pagination: data.pagination,
      };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createUserDrivingPermit = createAsyncThunk(
  USER_ACTIONS.createUserDrivingPermit,
  async (permit: IUserDrivingPermitPatchData, { rejectWithValue }) => {
    try {
      const data = await UserDrivingPermitService.createUserDrivingPermit(permit);
      const id = Object.values(data?.userDrivingPermit)?.[0]?.attributes?.id;

      return { id, data };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const editUserDrivingPermit = createAsyncThunk(
  USER_ACTIONS.editUserDrivingPermit,
  async (
    {
      id,
      data,
    }: {
      id: string;
      data: IUserDrivingPermitPatchData;
    },
    { rejectWithValue }
  ) => {
    try {
      return await UserDrivingPermitService.editUserDrivingPermit(id, data);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteUserDrivingPermit = createAsyncThunk(
  USER_ACTIONS.deleteUserDrivingPermit,
  async (id: string, { rejectWithValue }) => {
    try {
      await UserDrivingPermitService.deleteUserDrivingPermit(id);
      return {
        path: API_ENDPOINTS.USER_DRIVING_PERMIT(id),
        dataKey: IDataKeys.userDrivingPermit,
      };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
